import _objectWithoutPropertiesLoose from "/opt/build/repo/node_modules/.pnpm/next@15.5.6_@babel+core@7.28.5_@opentelemetry+api@1.9.0_@playwright+test@1.56.1_babel-p_096ab9bbeffdff0fc88514782f3793fe/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js";
import _extends from "/opt/build/repo/node_modules/.pnpm/next@15.5.6_@babel+core@7.28.5_@opentelemetry+api@1.9.0_@playwright+test@1.56.1_babel-p_096ab9bbeffdff0fc88514782f3793fe/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
var _excluded = ["code", "copyButtonHidden", "copyButtonProps", "language", "plainStyle", "parentComponent", "preComponent"];
import * as React from 'react';
import prism from '@mui/internal-markdown/prism';
import { NoSsr } from '@mui/base/NoSsr';
import { styled } from '@mui/material/styles';
import { useCodeCopy, CodeCopyButton } from '../CodeCopy';
import { MarkdownElement } from '../MarkdownElement';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var Pre = styled('pre')(function (_ref) {
  var theme = _ref.theme;
  return {
    margin: 0,
    color: 'hsl(60deg 30% 96.08%)',
    // fallback color until Prism's theme is loaded
    WebkitOverflowScrolling: 'touch',
    // iOS momentum scrolling.
    '& code': _extends({}, theme.typography.caption, {
      fontFamily: theme.typography.fontFamilyCode,
      fontWeight: 400,
      WebkitFontSmoothing: 'subpixel-antialiased'
      // Reset for Safari
      // https://github.com/necolas/normalize.css/blob/master/normalize.css#L102
    })
  };
});
export function HighlightedCode(props) {
  var code = props.code,
    _props$copyButtonHidd = props.copyButtonHidden,
    copyButtonHidden = _props$copyButtonHidd === void 0 ? false : _props$copyButtonHidd,
    copyButtonProps = props.copyButtonProps,
    language = props.language,
    plainStyle = props.plainStyle,
    _props$parentComponen = props.parentComponent,
    Component = _props$parentComponen === void 0 ? plainStyle ? React.Fragment : MarkdownElement : _props$parentComponen,
    _props$preComponent = props.preComponent,
    PreComponent = _props$preComponent === void 0 ? plainStyle ? Pre : 'pre' : _props$preComponent,
    other = _objectWithoutPropertiesLoose(props, _excluded);
  var renderedCode = React.useMemo(function () {
    return prism(code.trim(), language);
  }, [code, language]);
  var handlers = useCodeCopy();
  var componentProps = !plainStyle ? other : undefined;
  return /*#__PURE__*/_jsx(Component, _extends({}, componentProps, {
    children: /*#__PURE__*/_jsxs("div", _extends({
      className: "MuiCode-root"
    }, handlers, {
      style: {
        height: '100%'
      },
      children: [copyButtonHidden ? null : /*#__PURE__*/_jsx(NoSsr, {
        children: /*#__PURE__*/_jsx(CodeCopyButton, _extends({
          code: code
        }, copyButtonProps))
      }), /*#__PURE__*/_jsx(PreComponent, {
        children: /*#__PURE__*/_jsx("code", {
          className: "language-".concat(language)
          // eslint-disable-next-line react/no-danger
          ,
          dangerouslySetInnerHTML: {
            __html: renderedCode
          }
        })
      })]
    }))
  }));
}